(function() {
    $(document).ready(function() {

        $featuredServiceArea = $('.js-featured-service-area-trigger');
        $featuredCloseButton = $('.js-collapsible-feature-close');
        $featuredServicePanel = $('.js-featured-service-trigger');

        //close button
        $featuredCloseButton.click(function() {
            $featuredServiceArea.slideUp("slow");
        });

        //open featured content
        $featuredServicePanel.click(function() {
            $featuredServiceArea.slideUp('slow');
            //Do Ajax call and then do slideDown after response
            $featuredServiceArea.slideDown('slow');
        });
    });
})();